/* istanbul ignore file */
import { Route, Routes } from 'react-router-dom';
import { GameLayout } from '@/components/layout/game/GameLayout';
import { GameDashboardPage } from '@/pages/game/dashboard/GameDashboardPage';
import { NotFound } from '@/pages/NotFound';

export const GameRoutes = () => (
  <Routes>
    <Route element={<GameLayout />}>
      <Route path="dashboard" element={<GameDashboardPage />} />
    </Route>
    <Route path="*" element={<NotFound />} />
  </Routes>
);
